import logo from './logo.svg';
import './App.css';
import SearchBar from './components/searchbar';
import WeatherDisplay from './components/weatherdisplay';
import React, { useState } from 'react';



function App() {
  const [weatherData, setWeatherData] = useState({});
  return (
    <div className="App">
      <header className="App-header">
        <WeatherDisplay weatherData={weatherData} />
        <SearchBar setWeatherData={setWeatherData} />
      </header>
    </div>
  );
}

export default App;
